import { Injectable } from '@angular/core';
import { AssetListSortType, AssetListSortTypes } from '../../../models';

@Injectable()
export class AssetExportSorterService {
  public sortAssets(assets: any[], sortType: AssetListSortTypes, affectedAssets: Record<string, any>): any[] {
    if (!assets?.length) {
      return assets;
    }

    const sorted: any[] = [...assets];
    switch (sortType) {
      case AssetListSortType.releaseDate:
        return this.sortByReleaseDate(sorted);
      case AssetListSortType.status:
        return this.sortByStatus(sorted, affectedAssets);
      case AssetListSortType.lastUpdated:
        return this.sortByLastUpdated(sorted);
      case AssetListSortType.alphabetical:
        return this.sortByAlphabetical(sorted);
      default:
        return sorted;
    }
  }

  private sortByReleaseDate(assets: any[]): any[] {
    return assets.sort((a: any, b: any) => {
      const aRecord: { releaseDate?: { year?: number; month?: number; day?: number } } = a as {
        releaseDate?: { year?: number; month?: number; day?: number };
      };
      const bRecord: { releaseDate?: { year?: number; month?: number; day?: number } } = b as {
        releaseDate?: { year?: number; month?: number; day?: number };
      };
      const aTime: number = this.getReleaseDateTime(aRecord);
      const bTime: number = this.getReleaseDateTime(bRecord);
      return bTime > aTime ? 1 : -1;
    });
  }

  private getReleaseDateTime(asset: { releaseDate?: { year?: number; month?: number; day?: number } }): number {
    if (!asset.releaseDate?.year) {
      return 0;
    }
    return new Date(asset.releaseDate.year, asset.releaseDate.month - 1, asset.releaseDate.day).getTime();
  }

  private sortByStatus(assets: any[], affectedAssets: Record<string, any>): any[] {
    return assets.sort((a: any, b: any) => {
      const aRecord: { id: string } = a as { id: string };
      const bRecord: { id: string } = b as { id: string };
      const aStatus: string = (affectedAssets[aRecord.id] as { status?: string } | undefined)?.status || '';
      const bStatus: string = (affectedAssets[bRecord.id] as { status?: string } | undefined)?.status || '';
      return aStatus > bStatus ? 1 : -1;
    });
  }

  private sortByLastUpdated(assets: any[]): any[] {
    return assets.sort((a: any, b: any) => {
      const aRecord: { updatedAt?: string } = a as { updatedAt?: string };
      const bRecord: { updatedAt?: string } = b as { updatedAt?: string };
      const aTime: number = aRecord.updatedAt ? new Date(aRecord.updatedAt).getTime() : 0;
      const bTime: number = bRecord.updatedAt ? new Date(bRecord.updatedAt).getTime() : 0;
      return bTime > aTime ? 1 : -1;
    });
  }

  private sortByAlphabetical(assets: any[]): any[] {
    return assets.sort((a: any, b: any) => {
      const aRecord: { title?: string; detail?: string } = a as { title?: string; detail?: string };
      const bRecord: { title?: string; detail?: string } = b as { title?: string; detail?: string };
      const aName: string = aRecord.title || aRecord.detail || '';
      const bName: string = bRecord.title || bRecord.detail || '';
      return aName > bName ? 1 : -1;
    });
  }
}
